<template>
  <div class="cms-frame-mask" v-if="visible">
    <div class="frame-body">
      <img src="../img/corner-t-icon.png" alt="" class="top left">
      <img src="../img/corner-t-icon.png" alt="" class="top right">
      <img src="../img/corner-b-icon.png" alt="" class="bottom right">
      <img src="../img/corner-b-icon.png" alt="" class="bottom left">
      <em class="close" @click="close"></em>
      <video-player class="frame" :class="isIE ? 'classie' : ''" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import '../less/frame.css';
export default {
  name: 'CmsVideoPlayer',
  components: {videoPlayer},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    }
  },
  data() {
  	return {
		isIE: false
	}
  },
  mounted() {
  	if (document.documentMode)
  		this.isIE = true;
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = null;
      }
    }
  },
  computed: {
    playerOptions() {
      const options = {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        poster: this.poster,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      };
      options.sources.push({ type: "video/mp4", src: this.src });
      return options;
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsVideoPlayer.vue